export default function translate(i18n, propriete) {
  if (propriete === 'facture.logoTailleX') {
    return i18n.t('addEditRegleFacturation.errors.logoFactureTailleX');
  }
  if (propriete === 'facture.logoTailleY') {
    return i18n.t('addEditRegleFacturation.errors.logoFactureTailleY');
  }
  if (propriete === 'relance1.logoTailleX') {
    return i18n.t('addEditRegleFacturation.errors.logoRelance1TailleX');
  }
  if (propriete === 'relance1.logoTailleY') {
    return i18n.t('addEditRegleFacturation.errors.logoRelance1TailleY');
  }
  if (propriete === 'relance2.logoTailleX') {
    return i18n.t('addEditRegleFacturation.errors.logoRelance2TailleX');
  }
  if (propriete === 'relance2.logoTailleY') {
    return i18n.t('addEditRegleFacturation.errors.logoRelance2TailleY');
  }
  if (propriete === 'relance3.logoTailleX') {
    return i18n.t('addEditRegleFacturation.errors.logoRelance3TailleX');
  }
  if (propriete === 'relance3.logoTailleY') {
    return i18n.t('addEditRegleFacturation.errors.logoRelance3TailleY');
  }
  return propriete;
}
